export default "__VITE_ASSET__B5qney7M__"